import {
  PRIORITY_RULES_REQUEST,
  PRIORITY_RULES_FAILURE,
  FETCH_PRIORITY_RULES_SUCCESS,
  CREATE_PRIORITY_RULE_SUCCESS,
  UPDATE_PRIORITY_RULE_SUCCESS,
  DELETE_PRIORITY_RULE_SUCCESS,
  TOGGLE_PRIORITY_RULE_SUCCESS,
} from "../action/types";

const initialState = {
  rules: [],
  total: 0,
  loading: false,
  fetched: false,
  error: null,
};

const priorityRulesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case PRIORITY_RULES_REQUEST:
      return { ...state, loading: true, error: null };

    case PRIORITY_RULES_FAILURE:
      return { ...state, loading: false, fetched: true, error: payload };

    case FETCH_PRIORITY_RULES_SUCCESS:
      return {
        ...state,
        loading: false,
        fetched: true,
        rules: payload?.data ?? (Array.isArray(payload) ? payload : []),
        total:
          payload?.total ??
          (Array.isArray(payload) ? payload.length : 0),
      };

    case CREATE_PRIORITY_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: [...state.rules, payload],
        total: state.total + 1,
      };

    case UPDATE_PRIORITY_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: state.rules.map((r) =>
          r.id === payload.id ? { ...r, ...payload } : r,
        ),
      };

    case DELETE_PRIORITY_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: state.rules.filter((r) => r.id !== payload),
        total: Math.max(state.total - 1, 0),
      };

    case TOGGLE_PRIORITY_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: state.rules.map((r) =>
          r.id === payload.id ? { ...r, active: payload.active } : r,
        ),
      };

    default:
      return state;
  }
};

export default priorityRulesReducer;
